import { render, staticRenderFns } from "./BlogCallout.vue?vue&type=template&id=9b491748&scoped=true&"
import script from "./BlogCallout.vue?vue&type=script&lang=js&"
export * from "./BlogCallout.vue?vue&type=script&lang=js&"
import style0 from "./BlogCallout.vue?vue&type=style&index=0&id=9b491748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b491748",
  null
  
)

export default component.exports